export default function Version() {
	return (
		<div>
			<p>Version: {process.env.REACT_APP_VERSION}</p>
		</div>
	);
}
